export function sanitizeSheetName(name: string) {
  return name.replace(/[\\/?*[\]]/g, ' ')
}